import { Box } from '@chakra-ui/react';
import Text from '@molecules/Text';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BEButton from '@molecules/Button/Button';
import ModalAboutProperty from '@view/components/Modals/AboutProperty/ModalAboutProperty';
import { useModal } from '@molecules/BEOffScreen';

const LESS_TEXT_LIMIT = 840;

const Description = ({ description }: { description: string }) => {
  const { t } = useTranslation();
  const modal = useModal(ModalAboutProperty, {});
  const [cropped, setCropped] = useState<boolean>(false);

  useEffect(() => {
    setCropped(description.length > LESS_TEXT_LIMIT);
  }, [description]);

  return (
    <>
      <Text
        className="info-body"
        type="body"
        html={description}
        maxLines={10}
      />
      {cropped && (
        <Box>
          <BEButton
            color="primary"
            variant="outline"
            onClick={() => modal?.open()}
          >
            {t('read-more-button')}
          </BEButton>
        </Box>
      )}
    </>
  );
};

export default Description;
